/** Bedrock inference profile for Wave agent jobs (cross-region, eu-west-1 compatible). */
export const WAVE_AGENT_MODEL_ID = "global.anthropic.claude-haiku-4-5-20251001-v1:0";
